<template lang="pug">
    d2-container
      el-form(:inline='true', :model='dataForm'  size='mini' label-position='right' label-width='75px' label-suffix=':')
        el-row(:span='24')
          el-col(:md='6' :sm='8')
             el-form-item(label='订单编号')
                el-input.inputWidth(v-model='dataForm.orderId', placeholder='订单编号', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='场地ID')
                el-input.inputWidth(v-model='dataForm.placeId', placeholder='场地ID', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='账号' label-position='right')
                el-input.inputWidth(v-model='dataForm.accountId', placeholder='账号', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='姓名' label-position='right')
                el-input.inputWidth(v-model='dataForm.name', placeholder='姓名', clearable='')
        el-row(:span='24')
          el-col(:md='6' :sm='8')
             el-form-item(label='订单日期')
                 el-date-picker(style='width:210px', v-model='dataForm.rangeTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
          el-col(:md='6' :sm='8')
             el-form-item(label='状态' )
                el-select.inputWidth(v-model='dataForm.status' clearable)
                  el-option(v-for="item in statusData" :label="item.name" :value="item.code")
                  //-  el-option(label="未支付" value=0)
                  //-  el-option(label="支付中" value=1)
                  //-  el-option(label="支付成功" value=2)
                  //-  el-option(label="支付失败" value=3)
                  //-  el-option(label="支付已关闭" value=9)
                  //-  el-option(label="超时" value=4)
                  //-  el-option(label="申请退款" value=5)
                  //-  el-option(label="退款中" value=6)
                  //-  el-option(label="退款成功" value=7)
                  //-  el-option(label="退款失败" value=8)
                  //-  el-option(label="退款已取消" value=10)
          el-col(:md='6' :sm='8')
             el-form-item(label='主办方' label-position='right')
                el-input.inputWidth(v-model='dataForm.orgName', placeholder='主办方', clearable='')
        el-row(:span='24')
          el-col(:span='12' style="padding-bottom:15px;")
            el-button(@click='exportExcel()' type='primary' style='float:left;' v-if="isAuth('')" ) 列表导出
          el-col(:span='12' style="padding-bottom:15px;")
            el-button(@click="getDataList('query')",type='primary',icon='el-icon-search' style='float:right;') 查 询
          el-col(:span='24' style="padding-bottom:15px;")
            div(class="money_box")
              div()
                  span() 实际营收： 
                  span() ￥{{revenueMoney}}元
              div()
                  span() 退款总额： 
                  span() ￥{{refundMoney}}元
              div()
                  span() 支付总额： 
                  span() ￥{{totalMoney}}元
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)
            el-table-column(prop='id' header-align='center',align='center',label='订单编号'  )
            el-table-column(prop='payTime' header-align='center',align='center',label='订单日期')
            el-table-column(header-align='center',align='center',label='场地名称')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.name }}
            el-table-column(prop='orgName' header-align='center',align='center',label='主办方')
            el-table-column(header-align='center',align='center',label='场地ID')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.id }}
            el-table-column(header-align='center',align='center',label='场地属性')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.type }}
            el-table-column(header-align='center',align='center',label='场地号')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.fieldNo }}
            el-table-column(header-align='center',align='center',label='日期')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.day }}
            el-table-column(header-align='center',align='center',label='时间段')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.startTime }} ~ {{ scope.row.placeMode.endTime }}
            el-table-column(prop='userName' header-align='center',align='center',label='姓名')
            el-table-column(prop='account' header-align='center',align='center',label='账号')
            el-table-column(header-align='center',align='center',label='支付金额')
              template(slot-scope="scope")
                template( v-if="scope.row.payAmount")
                  font ￥{{ parseFloat(scope.row.payAmount).toFixed(2) }}元
                template(v-else)
                  font ￥0.00元
            el-table-column( header-align='center',align='center',label='退款比例')
               template(slot-scope="scope")
                template(v-if="scope.row.refundProportion")
                  font {{ scope.row.refundProportion }}%
            el-table-column(header-align='center',align='center',label='退款金额')
               template(slot-scope="scope")
                 template( v-if="scope.row.refundMoney")
                   font ￥{{ parseFloat(scope.row.refundMoney).toFixed(2) }}元
            el-table-column(prop='status' header-align='center',align='center',label='状态')
            //- el-table-column(prop='remark' header-align='center',align='center',label='备注')
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 30]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //- detail(v-if='detailVisiable', ref="detail", @refreshDataList='getDataList')
</template>
<script>
import table from './table.js'
import { commomDictData } from '@/util/dictionary' // 字典项
import { get30DaysArray } from '@/util/dateUtils'

export default {
  name: 'finance-competitionOrder-reserveSite',
  data () {
    return {
      table: {
          columns: table.columns,
          data: null,
          size: 'mini',
          stripe: true,
          border: true
      },
      isCollapse: true,
      detailVisiable: false,
      dataForm: { // 约场地订单查询参数
        accountId: '',
        rangeTime: [],
        beginTime: '',
        endTime: '',
        name: '',
        orderId: '',
        placeId: '',
        status: '',
        orgName: ''
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      totalMoney: null,
      refundMoney: null,
      revenueMoney: null,
      statusData: [] // 支付状态
    }
  },
  mounted () {
    this.dataForm.rangeTime = get30DaysArray()
    this.getDataList()
     // 支付状态取字段项
    commomDictData('pay_status', this).then(res => {
        this.statusData = res.list
    })
  },
  methods: {
    // 获取数据列表
    getDataList (type) {
      if (type) {
        this.pageIndex = 1
      }
      this.dataListLoading = true
      let [startTime = null, endTime = null] = this.dataForm.rangeTime || []
      this.dataForm.beginTime = startTime
      this.dataForm.endTime = endTime
      console.log(this.dataForm)
      this.$http({
        url: this.$http.adornUrl('/payOrder/reserve-list'),
        method: 'POST',
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize
        }),
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.data.rows
          this.totalPage = data.data.total
          this.getTotalMoney()
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    getTotalMoney () {
      this.$http({
        url: this.$http.adornUrl('/payOrder/reserve-list-money'),
        method: 'POST',
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
          this.totalMoney = data.data.total_money
          this.revenueMoney = data.data.total_earnings
          this.refundMoney = data.data.total_refund
        } else {
          this.totalMoney = 0
          this.revenueMoney = 0
          this.refundMoney = 0
        }
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    exportExcel () {
      //导出列表
      let [startTime = null, endTime = null] = this.dataForm.rangeTime || []
      this.dataForm.beginTime = startTime
      this.dataForm.endTime = endTime
      this.$http({
        url: this.$http.adornUrl('/payOrder/reserve-list'),
        method: 'POST',
        params: this.$http.adornParams({ // 后台要求如此
          page: 1,
          limit: 99999999
        }),
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
            if (!data.data || data.data.rows.length === 0) {
                this.$message.info('没有要导出的数据!')
                return
            }
            let exportData = data.data.rows
            for (let i of exportData) {
                i.payAmount = i.payAmount ? '¥' + i.payAmount + '元' : '¥0元'
                i.refundScale = i.refundScale ? i.refundScale + '%' : ''
                i.totalAmount = i.totalAmount ? '¥' + i.totalAmount + '元' : ''
                i.refundMoney = i.refundMoney ? '¥' + i.refundMoney + '元' : ''
                i.refundProportion = i.refundProportion ? i.refundProportion + '%' : ''
                i.placeModeName = i.placeMode.name
                i.placeModeId = i.placeMode.id
                i.placeModeType = i.placeMode.type
                i.placeModeFieldNo = i.placeMode.fieldNo
                i.dateRange = i.placeMode.startTime + '-' + i.placeMode.endTime // 时间段
                i.dateTime = i.placeMode.day// 日期
            }
            console.log('导出的订单数据：', exportData)
            this.$export.excel({
                columns: this.table.columns,
                data: exportData,
                title: '约场地订单'
            }).then(() => {
                this.$message.success('导出表格成功')
            })
        }
      })
    }
  }
}
</script>
<style>
.inputWidth {
  width: 210px;

}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
<style >
  /* 操作三点 菜单样式 */
@import '../../../css/opr3dot.css';
</style>
<style lang="scss" scoped>
.money_box{
  display: flex;
  flex-direction: row-reverse;
  div{
    margin: 0 10px;
    span{
      &:nth-child(2){
        color: red;
      }
    }
  }
}
</style>
